/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'waf-crs-list-page';
const componentName = 'waf-crs-list-page';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const columnTitleReleaseDate = `${prefix}.columnTitleReleaseDate`;
export const uploadCrsFileLabel = `${prefix}.uploadCrsFileLabel`;
export const uploadCrsFileHelperText = `${prefix}.uploadCrsFileHelperText`;
export const newReleaseLabel = `${prefix}.newReleaseLabel`;
export const downloadButtonLabel = `${prefix}.downloadButtonLabel`;

export const ENGLISH = {
    [headerLabel]: 'CRS',
    [columnTitleReleaseDate]: 'Release Date',
    [uploadCrsFileLabel]: 'Upload CRS File',
    [uploadCrsFileHelperText]: 'Max file size 10MB. Supported file types: .json',
    [newReleaseLabel]: 'New Release! {0} Available.',
    [downloadButtonLabel]: 'Download Now',
};
